import { useEffect, useState } from 'react';
import type { AltYBridgeContext } from '../types/global';

const bridgeType = 'idsys.alty.bridge';

export function useBridgeContext(activeFrame: HTMLIFrameElement | null, allowedOrigins: Set<string>) {
  const [context, setContext] = useState<AltYBridgeContext | null>(null);

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (event.origin !== window.location.origin && !allowedOrigins.has(event.origin)) return;
      if (activeFrame?.contentWindow && event.source !== activeFrame.contentWindow) return;
      if (!event.data || event.data.type !== bridgeType || event.data.action !== 'context') return;
      setContext(event.data.context || event.data);
    }

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [activeFrame, allowedOrigins]);

  return context;
}
